import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import Quiz from '@/views/quiz/Quiz.vue'
import QuizStart from '@/views/quiz/Start.vue'
import Timeline from '@/views/Timeline.vue'
import GalleryOverview from '@/views/gallery/Overview.vue'
import Gallery from '@/views/gallery/Gallery.vue'
import VideoOverview from '@/views/video/Overview.vue'
import Video from '@/views/video/Gallery.vue'
import ThenVsNowOverview from '@/views/then-vs-now/Overview.vue'
import ThenVsNow from '@/views/then-vs-now/ThenVsNow.vue'
import PuzzleOverview from '@/views/puzzle/Overview.vue'
import Puzzle from '@/views/puzzle/Puzzle.vue'
import Event from '@/views/event/Event.vue'
import EventOverview from '@/views/event/Overview.vue'
import Article from '@/views/article/Article.vue'
import ArticleOverview from '@/views/article/Overview.vue'

const routes = [{
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/timeline',
        name: 'Timeline',
        component: Timeline,
    },
    {
        path: '/article-overview',
        name: 'ArticleOverview',
        component: ArticleOverview,
    },
    {
        path: '/article/:id?',
        name: 'Article',
        component: Article,
    },
    {
        path: '/event-overview',
        name: 'EventOverview',
        component: EventOverview,
    },
    {
        path: '/event/:id?',
        name: 'Event',
        component: Event,
    },
    {
        path: '/gallery-overview/:categories?',
        name: 'GalleryOverview',
        component: GalleryOverview
    },
    {
        path: '/gallery/:id?',
        name: 'Gallery',
        component: Gallery
    },
    {
        path: '/puzzle-overview',
        name: 'PuzzleOverview',
        component: PuzzleOverview
    },
    {
        path: '/puzzle/:id?',
        name: 'Puzzle',
        component: Puzzle
    },
    {
        path: '/quiz',
        name: 'Quiz',
        component: Quiz
    },
    {
        path: '/quizstart',
        name: 'QuizStart',
        component: QuizStart
    },
    {
        path: '/video-overview',
        name: 'VideoOverview',
        component: VideoOverview
    },
    {
        path: '/video/:id?',
        name: 'Video',
        component: Video
    },
    {
        path: '/then-vs-now-overview',
        name: 'ThenVsNowOverview',
        component: ThenVsNowOverview
    },
    {
        path: '/then-vs-now/:id?',
        name: 'ThenVsNow',
        component: ThenVsNow
    }
]

var routerBaseUrl = process.env.BASE_URL

const router = createRouter({
    history: createWebHashHistory(routerBaseUrl),
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { left: 0, top: 0 }
    }
})

export default router